<script lang="ts" setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { PhHouse, PhCaretRight, PhCaretLeft } from '@phosphor-icons/vue'

import { usePageStore } from '@toni/rendering/src/stores/page'
import { Breadcrumb, BreadcrumbItem, BlockContainer } from '@toni/brand-ui'

import { BreadcrumbList } from '../../utils/breadcrumb-schema'
import { usePageBlockWidth } from '../../composables/use-page-block-width.ts'

const { t } = useI18n()

const props = defineProps<{ breadcrumbs: BreadcrumbList }>()

const mobileBreadcrumb = computed(() => {
  return props.breadcrumbs.length > 0 ? props.breadcrumbs[props.breadcrumbs.length - 1].name : 'Home'
})

const mobilePreviousUrl = computed(() => {
  const index = props.breadcrumbs.length - 1
  return index >= 0 ? props.breadcrumbs[index].url : '/'
})

const pageStore = usePageStore()
const brand = computed(() => pageStore.brandFromStore as string)
const isHome = computed(() => pageStore.isHome as boolean)
const size = computed(() => usePageBlockWidth(pageStore.pageData?.pageMeta, isHome.value, brand.value).value)
const isWide = computed(() => !isHome.value && pageStore.pageData?.pageMeta?.pageType === 'article')

const isSingleParent = computed(() => {
  return props.breadcrumbs.length === 0
})
</script>

<template>
  <BlockContainer :size="isWide ? 'wide' : size"
                  :class="isWide ? 'py-4 mt-2 mb-6 md:mt-4 md:mb-4' : 'my-6 md:my-8'">
    <Breadcrumb class="flex md:hidden">
      <BreadcrumbItem :url="mobilePreviousUrl">
        <template #icon>
          <PhCaretLeft size="18"
                       class="relative top-px" />
        </template>
        {{ t('breadcrumb.backTo') }} {{ mobileBreadcrumb }}
      </BreadcrumbItem>
    </Breadcrumb>
    <Breadcrumb class="hidden md:flex">
      <template v-if="isSingleParent">
        <BreadcrumbItem
          :url="breadcrumbs[0]?.url || '/'">
          <PhCaretLeft size="18"
                       class="relative top-px" />
          {{ t('breadcrumb.backTo') }} {{ breadcrumbs[0]?.name || 'Home' }}
        </BreadcrumbItem>
      </template>
      <template v-else>
        <BreadcrumbItem url="/">
          <PhHouse size="20" />
        </BreadcrumbItem>
        <BreadcrumbItem v-for="(item) in breadcrumbs"
                        :key="item.name"
                        :url="item.url"
                        class="gap-3">
          <template #icon>
            <PhCaretRight size="18"
                          class="relative top-px" />
          </template>
          {{ item.name }}
        </BreadcrumbItem>
      </template>
    </Breadcrumb>
  </BlockContainer>
</template>
